import React, {useState} from 'react'
import {NavLinks, NavigationContent, NavigationWrapper, MyWish1, YourWish1, BuyMePizza, Text1, Text2, Text3} from "./NavigationStyle"
import MyWish from "../My Wish/MyWish"
import YourWish from "../YouWish/YourWish"
import Pizza from "../Pizza/Pizza"

function Navigations() {
    const [myWishButton, setMyWishButton] = useState(true);
    const [yourWishButton, setYourWishButton] = useState(false);
    const [pizzaButton, setPizzaButton] = useState(false);

    const mywishfeed = () =>{
        setMyWishButton(true);
        setYourWishButton(false);
        setPizzaButton(false);
    };

    const yourwishfeed = () =>{
        setMyWishButton(false);
        setYourWishButton(true);
        setPizzaButton(false);
    };

    const pizzafeed = () =>{
        setMyWishButton(false);
        setYourWishButton(false);
        setPizzaButton(true);
    };

    return (
        <NavLinks>
            <NavigationWrapper>
            <MyWish1 onClick={mywishfeed}>
                <Text1>my wish</Text1>
            </MyWish1>
            <YourWish1 onClick={yourwishfeed}>
                <Text2>your wish</Text2>
            </YourWish1>
            <BuyMePizza onClick={pizzafeed}>
                <Text3>buy me a pizza</Text3>
            </BuyMePizza>
            </NavigationWrapper>
<br />
            <NavigationContent>
                {myWishButton ? (
                    <MyWish />
                ) : yourWishButton ? (
                    <YourWish />
                ) : pizzaButton ? (
                    <Pizza />
                ) : null}
            </NavigationContent>
        </NavLinks>
        
    )
}

export default Navigations
